export state = ->

	# Shopify customer zip
	id: null
	zip: null
	email: null
	tags: []

	# Store zip from age gate, which may be different
	ageGateZip: null

export mutations =

	# Store customer params
	setInfo: (state, params) ->
		state.id = params.id
		state.zip = parseInt params.zip
		state.email = params.email
		state.tags = params.tags

	# Store their age gate zip
	setAgeGateZip: (state, zip) -> state.ageGateZip = parseInt zip
